/* PZ Sep26 #5: collection card hover video. Desktop pointer devices only (hover: hover, pointer: fine).
   Markup: product-card-1/4.liquid (video.pz-card-video inside .m-product-card__media, preload="none").
   mouseenter -> play (muted); mouseleave -> pause + reset to 0. Delegated, so cards appended by infinite scroll work. */
(function () {
  if (window.__pzCardHoverVideo) return;
  window.__pzCardHoverVideo = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function mediaOf(t) { return t && t.closest ? t.closest('.m-product-card__media') : null; }
  function videoOf(m) { return m ? m.querySelector('video[data-pz-card-video]') : null; }

  document.addEventListener('mouseover', function (e) {
    var m = mediaOf(e.target);
    if (!m || (e.relatedTarget && m.contains(e.relatedTarget))) return; /* moving within the card: ignore */
    var v = videoOf(m);
    if (!v) return;
    m.classList.add('is-pz-video-playing');
    v.muted = true;
    var p;
    try { p = v.play(); } catch (err) { return; }
    if (p && typeof p.catch === 'function') p.catch(function () { m.classList.remove('is-pz-video-playing'); });
  });

  document.addEventListener('mouseout', function (e) {
    var m = mediaOf(e.target);
    if (!m || (e.relatedTarget && m.contains(e.relatedTarget))) return;
    var v = videoOf(m);
    if (!v) return;
    m.classList.remove('is-pz-video-playing');
    v.pause();
    try { v.currentTime = 0; } catch (err) {}
  });
})();
